import { BrowserRouter, Route, Routes } from 'react-router-dom'
import React from 'react'
import TestPsicolottico from '../../pages/test-psicolottico'
import NumeriCaldiNomi from '../../pages/numeri-associati-ai-nomi'
import SignificatiNumeriAmore from '../../pages/significati-numeri-amore'
import NumeriVincentiCucina from '../../pages/numeri-vincenti-cucina'
import NumeriFortunatiOroscopo from '../../pages/numeri-fortunati-oroscopo'
import { PAGINE_CABALA_PATH } from '../../types/enums'

function CabalaRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={PAGINE_CABALA_PATH.NUMERI_NOME} element={<NumeriCaldiNomi />}></Route>
        <Route path={PAGINE_CABALA_PATH.NUMERI_TEST} element={<TestPsicolottico />}></Route>
        <Route path={PAGINE_CABALA_PATH.NUMERI_AMORE} element={<SignificatiNumeriAmore />}></Route>
        <Route path={PAGINE_CABALA_PATH.NUMERI_CUCINA} element={<NumeriVincentiCucina />}></Route>
        <Route
          path={PAGINE_CABALA_PATH.NUMERI_OROSCOPO}
          element={<NumeriFortunatiOroscopo />}></Route>
      </Routes>
    </BrowserRouter>
  )
}

export default CabalaRouter
